import { Flex } from 'components/base/layout-components';
import styled from 'styled-components';
import UserProfile from '../ProfilePanel';

const ProfileWrapper = styled(Flex)`
  flex-grow: 1;
  flex-basis: 0;
`;

const OnboardingStepper = ({ isOnTopOfModals }) => {
  return (
    <ProfileWrapper height='100%' items='center' justify='flex-end'>
      <UserProfile isOnTopOfModals={isOnTopOfModals} />
    </ProfileWrapper>
  );
};

export default OnboardingStepper;
